var _mask, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.48275862068965,
    height: 22.00054931640625,
    viewBox: "0 0 20.48275862068965 22.00054931640625",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(0 0)  rotate(0)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "bg-mask-0",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bg-mask-0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 1",
    fillRule: "evenodd",
    style: {
      fill: "#030000"
    },
    opacity: 1,
    d: "M0 1.59L20.48 1.59L20.48 0L0 0L0 1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 2",
    fillRule: "evenodd",
    style: {
      fill: "#030000"
    },
    opacity: 1,
    d: "M9.45562 22.0005L11.0256 22.0005L11.0256 5.41053L17.4856 11.9405L18.5956 10.8105L11.3556 3.49053L10.2456 2.36053L9.12562 3.49053L1.88562 10.8105L2.99562 11.9405L9.45562 5.41053L9.45562 22.0005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path_0",
    x: 0,
    y: 0,
    width: 20.48275862068965,
    height: 22
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTop);
export default __webpack_public_path__ + "static/media/toTop.1c7f14eab83930b4c42eed75574f8687.svg";
export { ForwardRef as ReactComponent };